import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-message-dialog',
    templateUrl: './message-dialog.component.html',
    styleUrls: ['./message-dialog.component.scss']
    // `
    //   <h2 mat-dialog-title>Notice</h2>
    //   <mat-dialog-content>
    //     <p>{{ data.message }}</p>
    //   </mat-dialog-content>
    //   <mat-dialog-actions align="end">
    //     <button mat-button (click)="dialogRef.close()">OK</button>
    //   </mat-dialog-actions>
    // `,
    ,
    standalone: false
})
export class MessageDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<MessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
}
